<div class="camera-modal">

  <!-- HEADER -->
  <div class="camera-header" *ngIf="!isLandscape">
    <span class="title h3">Capture Photo</span>

    <button mat-icon-button mat-dialog-close
            (click)="closeModal()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- BODY -->
  <div class="camera-body">
    <!-- PREVIEW -->
    <div class="camera-preview"
         #cameraWrapper
         (pointerdown)="onTapToFocus($event)"
         (touchstart)="onTouchStart($event)"
         (touchmove)="onTouchMove($event)">

      <video #video autoplay playsinline></video>

      <!-- Focus ring should be AFTER video -->
      <div *ngIf="showFocusRing"
           class="focus-square"
           [style.left.px]="focusX"
           [style.top.px]="focusY">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>

    </div>

    <!-- CONTROLS -->
    <div class="camera-controls">
      <div class="camera-header" *ngIf="isLandscape">
        <span class="title h3">Capture Photo</span>

        <button class="mb-3" mat-icon-button mat-dialog-close
                (click)="closeModal()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <!-- zoom -->
      <input type="range"
             min="1"
             max="4"
             step="0.1"
             [value]="zoomLevel"
             (input)="zoomLevel = $any($event.target).value; onZoomSliderChange()" />

      <!-- action row -->
      <div class="capture-row">
        <button mat-stroked-button id="snap" color="secondary" (click)="startCamera()">
          Retake
        </button>

        <button *ngIf="!isTakePhoto"
                mat-raised-button id="snap"
                class="blue_button"
                (click)="capture()">
          Take Photo
        </button>

        <button *ngIf="isTakePhoto"
                mat-raised-button id="snap"
                class="blue_button"
                (click)="sendImage()">
          Use Photo
        </button>

        <button *ngIf="isLandscape"
                mat-raised-button class="blue_button"
                (click)="toggleCamera()">
          {{ toggleButtonText }}
        </button>
      </div>

      <button mat-raised-button class="blue_button" *ngIf="!isLandscape"
              (click)="toggleCamera()">
        {{ toggleButtonText }}
      </button>

    </div>

  </div>

  <canvas #canvas style="display:none;"></canvas>

</div>


<!--<div class="modal-container">-->
<!--  <div class="modal-header">-->
<!--    <span class="ms-4 h5">Capture Photo</span>-->
<!--    <button-->
<!--      class="float-end"-->
<!--      mat-icon-button-->
<!--      mat-dialog-close-->
<!--      aria-label="Close dialog"-->
<!--      (click)="closeModal()"-->
<!--    >-->
<!--      <mat-icon>close</mat-icon>-->
<!--    </button>-->
<!--  </div>-->

<!--  <div class="modal-body text-center">-->
<!--    <button-->
<!--      mat-raised-button-->
<!--      id="toggle"-->
<!--      class="blue_button mb-3"-->
<!--      (click)="toggleCamera()"-->
<!--    >-->
<!--      {{ toggleButtonText }}-->
<!--    </button>-->

<!--    <div id="app">-->
<!--      <video #video id="video" autoplay playsinline></video>-->

<!--      <div class="button-row">-->
<!--        <button-->
<!--          mat-stroked-button-->
<!--          id="snap"-->
<!--          color="secondary"-->
<!--          (click)="startCamera()"-->
<!--        >-->
<!--          Retake-->
<!--        </button>-->

<!--        <button-->
<!--          *ngIf="!isTakePhoto"-->
<!--          mat-raised-button-->
<!--          id="snap"-->
<!--          class="blue_button ms-3"-->
<!--          (click)="capture()"-->
<!--        >-->
<!--          Take photo-->
<!--        </button>-->

<!--        <button-->
<!--          *ngIf="isTakePhoto"-->
<!--          mat-raised-button-->
<!--          id="snap"-->
<!--          class="blue_button ms-3"-->
<!--          (click)="sendImage()"-->
<!--        >-->
<!--          Use this photo-->
<!--        </button>-->
<!--      </div>-->

<!--      <canvas-->
<!--        #canvas-->
<!--        id="canvas"-->
<!--        height="480"-->
<!--        style="display: none; width: 100%;"-->
<!--      ></canvas>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->
